/* eslint-disable no-irregular-whitespace */
<template>
  <div class="item-box-content" style="padding-bottom:20px;">
    <div class="title-font-style">
      <span>收货信息</span>
    </div>
    <!-- class="details-line-height" -->
    <el-form style="padding:10px 10px 0 30px;" :model="params" label-position="left">
      <el-row v-if="flag === true">
        <el-col :span="8">
          <el-form-item label="备货仓：">
            <el-select
              style="width:60%"
              @change="changeName"
              v-model="params.storageId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.storageName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="">
            <div class="flex">
              <div class="nowrap">收货地址：</div>
              <div>{{params.address}}</div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话：">
            <span>{{params.phone||'--'}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flag === false && params.stockupType === '直发备货'">
        <el-col :span="8">
          <el-form-item label="收货人：">{{typeparams.receivePeople}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="">
            <div class="flex">
              <div class="nowrap">收货地址：</div>
              <div>{{typeparams.receiveAddress}}</div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话：">
            <span>{{typeparams.receivePhone}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flag === false && params.stockupType === '入库备货'">
        <el-col :span="8">
          <el-form-item label="备货仓：">{{typeparams.storageName}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="">
            <div class="flex">
              <div class="nowrap">仓库地址：</div>
              <div>{{typeparams.address}}</div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话：">
            <span>{{typeparams.phone}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { queryAllByFlag } from '@/api/purchase/purchasePlanList'
export default {
  data() {
    return {
      params: { address: '', phone: '' },
      typeparams: {}, // 直发备货
      options: [],
      flag: ''
    }
  },
  methods: {
    onInitial(val) {
      this.flag = val.flag
      this.params = val
      this.typeparams = val
      this.$emit('onInitialGoods', val)
      queryAllByFlag().then(res => {
        if (res.data.code === 200) {
          this.options = res.data.obj
        }
      })
    },
    changeName(item) {
      if (this.options.length > 0) {
        const i = this.options.findIndex(ele => ele.id === item)
        if (i !== -1) {
          this.params.address = this.options[i].storageAddress
          // eslint-disable-next-line no-irregular-whitespace
          this.params.phone = this.options[i].storagePhone
          this.$emit('getGoods', this.params)
        }
      }
    }
  }
}
</script>
<style>
.el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}
.flex{
  display: flex;
}
.nowrap{
  white-space: nowrap;
}
</style>
